<template>
    <div id="popup" class="ui active dimmer" v-if="showModal">
        <div class="ui middle aligned center aligned grid">
            <div class="column">
                <h1 class="ui inverted header">{{ text }}</h1>
                <h3 class="ui inverted header">{{ description }}</h3>
                <br>
                <br>
                <button class="ui inverted red button" @click="onYesClick">
                    <i class="check icon"></i>
                    예
                </button>
                <button class="ui inverted grey button" @click="onNoClick">
                    <i class="close icon"></i>
                    아니오
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return { showModal: 0, title: 0, description: 0, onYes: 0, }
    },
    created: function() {
        this.showModal = false;
        this.text = this.description = this.onYes = 0;
    },
    mounted: function() {
        this.$event.set("openPopup", this.open);
        this.$event.set("closePopup", this.close);
    },
    beforeDestroyed: function() {
        this.$event.clear("openPopup");
        this.$event.clear("closePopup");
    },
    methods: {
        open(text, description, onYes) {
            this.text = text;
            this.description = description;
            this.showModal = true;
            this.onYes = onYes;
        },
        close() {
            this.showModal = false;
        },
        onYesClick() {
            this.onYes();
            this.showModal = false;
        },
        onNoClick() {
            this.showModal = false;
        },
    },
}
</script>

<style>

#popup {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#popup .column {
    max-width: 600px;
}

#popup .button {
    margin: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/Popup.vue